import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: ()=>import('../views/Home.vue')
      },
      {
        path:'/home',
        name:"Dashboard",
        component:()=>import('../views/Dashboard.vue')
      },
      {
        path:'/product',
        name:"Product",
        component:()=>import('../views/Product.vue')
      },
      {
        path:'/family',
        name:"Family",
        component:()=>import('../views/Family.vue')
      },
      {
        path:"/new-product",
        name:"NewProduct",
        component:()=>import('../views/NewProduct.vue')
      },
      {
        path:"/update-product",
        name:"UpdateProduct",
        component:()=>import('../views/UpdateProduct.vue'),
        props:{product:null}
      },
      {
        path:"/new-family",
        name:"NewFamily",
        component:()=>import('../views/NewFamily.vue'),
      },
      {
        path:"/update-family",
        name:"UpdateFamily",
        component:()=>import('../views/UpdateFamily.vue'),
        props:{family:null}
      },
      {
        path:"/estimate-gst",
        name:"EstimateGST",
        component:()=>import('../views/EstimateGST.vue'),
      },
      //make this route last one
      { path: "*", component: ()=>import('../views/PageNotFound.vue') }
]

const router = new VueRouter({
    routes,
    linkActiveClass: 'is-active'
  })
  
  router.beforeEach((to, from, next) => {
    if (to.name !== 'Home' && !store.state.isLoggedIn) next({ name: 'Home' })
    else if(to.name == 'Home' && store.state.isLoggedIn) next({name:'Dashboard'})
    else next()

  })
  export default router